import { render, staticRenderFns } from "./AlignerDetailDialog.vue?vue&type=template&id=1151ee4d&scoped=true"
import script from "./AlignerDetailDialog.vue?vue&type=script&lang=js"
export * from "./AlignerDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./AlignerDetailDialog.vue?vue&type=style&index=0&id=1151ee4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1151ee4d",
  null
  
)

export default component.exports